// extracted by mini-css-extract-plugin
module.exports = {"button":"WalletAndAddressButton_button__roYiz","icon":"WalletAndAddressButton_icon__3DeP-"};